import logger from '@/services/logger';

import EcommerceDataMapper from './ecommerce-data-mapper';


class EcommerceEvents {
  constructor(vueGtm, store) {
    this.vueGtm = vueGtm;
    this.mapper = EcommerceDataMapper.init(store);
  }

  static init(vueGtm, store) {
    return new EcommerceEvents(vueGtm, store);
  }

  post(eventName, eventData) {
    switch (eventName) {
      case 'view_item_list':
      case 'view_item':
      case 'add_to_cart':
      case 'view_cart':
      case 'remove_from_cart':
        this._dispatchEvent(eventName, this.mapper.mapItemData(eventData));

        break;
      case 'add_payment_info':
      case 'begin_checkout':
      case 'purchase':
        this._dispatchEvent(eventName, this.mapper.mapCheckoutData(eventData));

        break;
      case 'view_promotion':
      case 'select_promotion':
        this._dispatchEvent(eventName, this.mapper.mapPromotionData(eventData));

        break;
      default:
        logger.log('Invalid ecommerce event');

        break;
    }
  }

  _dispatchEvent(eventName, eventData) {
    if (this.vueGtm.enabled()) {
      /** Note: must clear previous ecommerce event first */
      this.vueGtm.trackEvent({ ecommerce: null });

      const eventPayload = { event: eventName, ecommerce: eventData };

      this.vueGtm.trackEvent(eventPayload);
    }
  }
}


export default EcommerceEvents;
